import React, { useState } from 'react';
import './LoginPage.css';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';

const ForgotPasswordPage = () => {
  const [step, setStep] = useState('request'); // 'request' | 'verify'
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || 'Failed to send OTP');
      }

      setMessage('OTP sent to your registered email (if it exists).');
      setStep('verify');
    } catch (err) {
      setMessage(err.message || 'Something went wrong. Please try again.');
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/api/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp, newPassword }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || 'Failed to reset password');
      }

      setMessage('Password reset successful. You can now log in with your new password.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setMessage(err.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Forgot Password</h2>
        <p>
          {step === 'request'
            ? 'Enter your registered email to receive an OTP.'
            : 'Enter the OTP you received and set a new password.'}
        </p>

        {message && (
          <p style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#444' }}>
            {message}
          </p>
        )}

        {step === 'request' ? (
          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button type="submit">Send OTP</button>

            <div className="login-footer">
              <span>Remembered your password? </span>
              <button
                type="button"
                className="link-button"
                onClick={() => navigate('/login')}
              >
                Back to Login
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleReset}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <label>OTP</label>
            <input
              type="text"
              name="otp"
              required
              placeholder="6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <label>New Password</label>
            <input
              type="password"
              name="newPassword"
              required
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <button type="submit">Reset Password</button>

            <div className="login-footer">
              <button
                type="button"
                className="link-button"
                onClick={() => setStep('request')}
              >
                Resend OTP
              </button>
              {' | '}
              <button
                type="button"
                className="link-button"
                onClick={() => navigate('/login')}
              >
                Back to Login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;

